import PropTypes from 'prop-types';

export default {
  name: PropTypes.string.isRequired,
  postcode: PropTypes.string.isRequired,
};
